interface Message {
  msg?: string;
  visible?: boolean;
  showClose: boolean;
  timeout?: number;
  color?: string;
  top?: boolean;
}

const snackbar = {
  namespaced: true,
  state: {
    msg: "",
    visible: false,
    showClose: true,
    timeout: 3000,
    color: "success",
    top: true
  } as Message,
  mutations: {
    OPEN_SNACKBAR(state: Message, options: Message) {
      state.visible = true;
      state.msg = options.msg;
      state.color = options.color;
    },
    CLOSE_SNACKBAR(state: Message) {
      state.visible = false;
    },
    setShowClose(state: Message, isShow: boolean) {
      state.showClose = isShow;
    },
    setTimeout(state: Message, options: Message) {
      state.timeout = options.timeout;
    },
    setColor(state: Message, options: Message) {
      state.color = options.color;
    }
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    openSnackbar(context: any, options: Message) {
      const timeout = context.state.timeout;
      context.commit("OPEN_SNACKBAR", {
        msg: options.msg,
        color: options.color
      });
      setTimeout(() => {
        context.commit("CLOSE_SNACKBAR");
      }, timeout);
    }
  }
};

export default snackbar;
